exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/my-dream-app/src/app/supply-chain-capacity-utilization-calculator/supply-chain-capacity-utilization-calculator.component.css
// module id = ../../../../../src/app/supply-chain-capacity-utilization-calculator/supply-chain-capacity-utilization-calculator.component.css
// module chunks = main